<!doctype html>
<div class="margin-horizontal-20">
  @if (loading) {
    <ds-localized-spinner
      class="block"
      [dataLoading]="loading"
      [loadingMessage]="'Looking for claim details'"
    >
    </ds-localized-spinner>
  }
</div>

@if (urlSafe) {
  <div class="flex">
    <iframe
      data-cy="claimsIframe"
      allowtransparency="true"
      class="iframe"
      [src]="urlSafe"
      style="
        -webkit-writing-mode: vertical-lr;
        writing-mode: vertical-lr;
        width: 100%;
        height: 100%;
      "
    ></iframe>
  </div>
}
